export function OpeningDayTraditionIcon() {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 48 48"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M12 38V18l12-10 12 10v20" />
      <rect x="20" y="26" width="8" height="12" />
      <path d="M8 20l16-14 16 14" />
      <line x1="24" y1="10" x2="24" y2="6" />
      <path d="M21 6h6" />
    </svg>
  );
}
